import React from "react";
import ReactModal from "react-modal";
import { LoadingButton } from "../shared/loading-button";

const RevertFundsModal = ({ open, sourceInfo, targetInfo, onSubmit, onClose, saving }) => {
  const sourceLabel = sourceInfo
    ? `Trip #${sourceInfo.tripTag} | Contract #${sourceInfo.contractTag}`
    : "";
  const targetLabel = targetInfo
    ? `Trip #${targetInfo.tripTag} | Contract #${targetInfo.contractTag}`
    : "";

  return (
    <ReactModal
      isOpen={open}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onClose}
      style={{
        overlay: {
          zIndex: 999999,
          backgroundColor: "rgb(32 53 68 / 50%)",
        },
        content: {
          width: "auto",
          border: "none",
          maxWidth: "700px",
          maxHeight: "80vh",
          minWidth: "calc(min(500px, 95vw))",
          borderRadius: "0",
          boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
        },
      }}
      appElement={document.getElementById("app")}
    >
      <div className="modal-header base-modal">
        <h4>Revert Funds Movement Between Trips/Contracts</h4>
      </div>

      <div className="modal-body base-modal overflow-scroll">
        <p className="mt-20">You are about to revert a funds movement between two Trips/Contracts:</p>
        <ul>
          {sourceLabel && <li>Source: {sourceLabel}</li>}
          {targetLabel && <li>Target: {targetLabel}</li>}
        </ul>
        <p>
          This action will permanently delete: related Client Payment records for both Trips/Contracts and both paired
          Funds Ledger records. This action cannot be undone. Are you sure you want to continue?
        </p>
      </div>

      <div className="modal-footer no-border w-100 d-flex gap-10">
        <button className="base-button evo-blue flex-half" onClick={onClose} disabled={saving} type="button">
          Cancel
        </button>

        <LoadingButton
          className="base-button btn-danger flex-half"
          onClick={onSubmit}
          isLoading={saving}
          type="button"
        >
          Submit
        </LoadingButton>
      </div>
    </ReactModal>
  );
};

export default RevertFundsModal;
